import React from 'react';
import PropTypes from 'prop-types';
import {
	makeStyles,
	Grid
} from '@material-ui/core';

const styles = makeStyles(theme => ({
	topPad: {
		[theme.breakpoints.up('sm')]: {
			// paddingTop: theme.spacing(2)
		}
	},

	bottomPad: {
		[theme.breakpoints.up('sm')]: {
			// paddingBottom: theme.spacing(2)
		}
	},

	item: {
		width: "100%",

		[theme.breakpoints.up('sm')]: {
			width: "70%",
		},

		[theme.breakpoints.up('xl')]: {
			width: "80%",
		}
	},

	itemLarge: {
		width: "100%",

		[theme.breakpoints.up('sm')]: {
			width: "90%",
		},

		[theme.breakpoints.up('md')]: {
			width: "85%",
		},

		[theme.breakpoints.up('lg')]: {
			width: "90%",
		}
	}
}));

function PaddedLayout(props) {
	const classes = styles();
	let {isLarge, containerClassName, className, noTopPad, noBottomPad} = props,
		itemClassName = `${className} ${isLarge ? classes.itemLarge : classes.item}`;

	return (
		<Grid
			container
			direction="column"
			alignItems="center"
			className={containerClassName}>
			<Grid item
				className={`${itemClassName} ${noTopPad === true ? "" : classes.topPad} ${noBottomPad === true ? "" : classes.bottomPad}`}>
				{props.children}
			</Grid>
		</Grid>
	);
}

PaddedLayout.propTypes = {
	containerClassName: PropTypes.string,
	className: PropTypes.string,
	isLarge: PropTypes.bool,
	noTopPad: PropTypes.bool,
	noBottomPad: PropTypes.bool,
	children: PropTypes.oneOfType([PropTypes.array, PropTypes.object])
};

export default PaddedLayout;